import { FontWeight, Markdown, Typography, TypographyElement, TypographyVariant } from '@elearning-platform/ui';
import React from 'react';

import { VideoSection } from '../../../../interactions';

import { HeadlineContainer, TextContainer, VideoContainer, Wrapper } from './videoWithText.styled';
import { VideoWithTextProps } from './videoWithText.types';

export const VideoWithText: React.FC<VideoWithTextProps> = (props: VideoWithTextProps): JSX.Element => {
  const { headline, description, videoSrc, callComplete }: VideoWithTextProps = props;

  return (
    <Wrapper>
      <VideoContainer>
        <VideoSection callComplete={callComplete} isScrollContent isScrollLesson videoSrc={videoSrc} />
      </VideoContainer>
      <TextContainer>
        <HeadlineContainer>
          <Typography fontWeight={FontWeight.Bold} variant={TypographyVariant.DisplayXS}>
            {headline}
          </Typography>
        </HeadlineContainer>
        <Typography tag={TypographyElement.div} variant={TypographyVariant.TextMD}>
          <Markdown text={description} />
        </Typography>
      </TextContainer>
    </Wrapper>
  );
};
